import React from 'react';
import CenterImage from './../CenterImage/CenterImage';

const LockImage = () => (
  <CenterImage
    image={
      <svg
        width="128px"
        height="128px"
        viewBox="0 0 128 128"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Custom-Preset"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="ic_settings_locked_128x128"
            transform="translate(34.000000, 24.000000)"
          >
            <g id="lock" transform="translate(0.450255, 0.330074)">
              <path
                d="M18.9246596,25.355784 L18.9205483,21.0971054 C18.9172592,14.3357645 24.5793892,8.83134471 31.5415233,8.8281505 C38.5036573,8.8249563 44.1715432,14.3237863 44.1748323,21.0851272 L44.1789437,29.081819 C44.1805882,30.5112274 45.3736975,31.6699265 46.8463776,31.6699265 L48.8823105,31.6699265 C50.3566351,31.6699265 51.5505666,30.5088317 51.5497444,29.0778263 L51.5456331,21.0811345 C51.5382326,10.3717518 42.5631892,1.66433932 31.5365897,1.66992919 C20.5099902,1.67551906 11.5439917,10.390917 11.5497475,21.1002997 L11.5538589,25.3605752 C11.5555034,26.7899836 12.7486127,27.9486827 14.2212928,27.9486827 L16.2572257,27.9486827 C17.7307281,27.9478842 18.9254818,26.7867894 18.9246596,25.355784 Z"
                id="Shape-Copy-4"
                fill="#7FBABA"
                fillRule="nonzero"
              />
              <path
                d="M3.94104913,33.2786222 L57.8540926,33.2786222 L57.8540926,75.1164329 C57.8540926,76.2210024 56.9586621,77.1164329 55.8540926,77.1164329 L5.94104913,77.1164329 C4.83647963,77.1164329 3.94104913,76.2210024 3.94104913,75.1164329 L3.94104913,33.2786222 Z"
                id="white-background"
                fill="#FFFFFF"
                fillRule="nonzero"
              />
              <path
                d="M48.5497448,30.1699265 L56.0481199,30.1699265 L56.0481199,71.6043135 C56.0481199,74.1192053 54.0159492,76.1746458 51.5330697,76.1746458 L4.5672344,76.1746458 C2.08435489,76.1746458 0.0521840983,74.1192053 0.0521840983,71.6043135 L0.0521840983,30.1699265 C3.56444797,30.1699265 6.68350542,30.1699265 8.43963736,30.1699265 M16.0497448,30.1699265 C16.0497448,30.1699265 30.4878767,30.1699265 42.0497448,30.1699265"
                id="Combined-Shape"
                stroke="#3B556A"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <g transform="translate(22.913043, 44.478261)" fill="#7FBABA">
                <circle id="Oval-28" cx="5.6367013" cy="5.19166563" r="5" />
                <path
                  d="M3.6367013,7.19166563 L7.6367013,7.19166563 L7.6367013,15.1916656 C7.6367013,16.2962351 6.7412708,17.1916656 5.6367013,17.1916656 L5.6367013,17.1916656 C4.5321318,17.1916656 3.6367013,16.2962351 3.6367013,15.1916656 L3.6367013,7.19166563 Z"
                  id="Rectangle-33"
                />
              </g>
              <path
                d="M16.0497448,30.1699265 L16.0736753,18.9944364 C16.0702928,12.478027 21.8933025,7.17300634 29.0532537,7.16992784 C36.2132049,7.16684934 42.042134,12.4664827 42.0455166,18.9828921 L42.0497448,23.1034608 M49.0497448,30.1699265 L49.0456407,18.7707667 C49.0382532,8.50847304 40.0789526,0.164572575 29.0716943,0.169929077 C18.0644361,0.17528558 9.11416441,8.5268382 9.11991018,18.7891318 L9.04974478,25.1699265"
                id="Shape"
                stroke="#365568"
                strokeWidth="3"
                strokeLinecap="round"
                transform="translate(29.049745, 15.169926) scale(-1, 1) translate(-29.049745, -15.169926) "
              />
              <path
                d="M53.5219868,35.1652092 C53.5219868,35.1652092 53.5219868,32.6699265 51.1573467,32.6699265 L9.54974478,32.6699265 C9.54974478,32.6699265 34.2063445,32.6699265 42.260306,38.7725368 C52.4242704,46.4739289 53.5497448,62.6699265 53.5497448,62.6699265 C53.5497448,62.6699265 53.5219868,35.1652092 53.5219868,35.1652092 Z"
                id="shadow"
                fill="#DFEBEB"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </svg>
    }
  />
);

export default LockImage;
